
import { mapGetters } from "vuex";
import { PAGES } from "@/common/consts";

export default {
	name: "WordleCTA",
	props: {
		cssClass: {
			type: String,
			default: "",
		},
	},
	computed: {
		...mapGetters("navigation", ["isWordleResultsPage"]),
		ctaLink() {
			const name = this.isWordleResultsPage
				? PAGES.WORDLE_HINTS
				: PAGES.WORDLE;

			return `${this.$router.resolve({ name }).href}/`;
		},
		ctaText() {
			return this.isWordleResultsPage
				? "Take me to the answer"
				: "Try our Wordle Solver";
		},
		msgText() {
			return this.isWordleResultsPage
				? "Want to see today’s Wordle answer instead?"
				: "Need help finding today’s Wordle answer?";
		},
	},
	methods: {
		onClick() {
			if (!this.isWordleResultsPage) {
				this.$store.dispatch("tracking/trackEvent", {
					eventCategory: "Wordle CTA",
					eventAction: "Click Wordle CTA button",
				});
			}
		},
	},
};
